import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, PaletteIcon, CheckCircleIcon } from 'lucide-react';
const FEATURES = [{
  icon: BookOpenIcon,
  title: 'Historia completa y en orden',
  text: 'De la Creación al Apocalipsis, entiende el hilo completo de la Biblia.'
}, {
  icon: PaletteIcon,
  title: 'Arte estilo novela gráfica',
  text: 'Ilustraciones vibrantes que capturan la imaginación.'
}, {
  icon: CheckCircleIcon,
  title: 'Fiel a la Escritura',
  text: 'Cada relato indica el pasaje bíblico en que se basa.'
}];
export function SolutionSection() {
  return <section className="w-full bg-cream" data-id="element-131" data-mp="atcnj7jct5sx">
      <div className="mx-auto max-w-6xl px-4 py-5 md:py-6" data-id="element-132" data-mp="aw8jiqbn5keq">
        <div className="grid grid-cols-1 items-center gap-6 md:grid-cols-2" data-id="element-133" data-mp="5wm3ya8cbs2r">
          <motion.img initial={{
          opacity: 0,
          x: -24
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} src="https://cdn.magicpatterns.com/patterns/generated-images/737e524b-173f-4ead-ab6e-e8ad833a2a4f.jpg" alt="Páginas interiores de La Biblia en Cómic abiertas en abanico" className="w-full rounded-card shadow-soft" data-id="element-134" data-mp="krsdv8ak4b1d" />

          <div data-id="element-135" data-mp="3fdn7hfdu0b3x">
            <h2 className="font-display text-3xl font-bold leading-tight text-deep-blue md:text-[38px]" data-id="element-136" data-mp="3ka57y324pnag">
              La misma Palabra de siempre. Contada como una{' '}
              <span className="mark-gold" data-id="element-137" data-mp="3p7dsubenw5fe">épica</span> que no van a poder soltar.
            </h2>
            <p className="mt-4 text-[17px] font-medium text-ink/90" data-id="element-138" data-mp="3u6gm6yla4n7j">
              El resultado, según cientos de padres que ya probaron el formato:
              niños que la leen de principio a fin por voluntad propia... y
              después la vuelven a empezar.
            </p>
          </div>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-3" data-id="element-139" data-mp="bsqx9zpeauw2">
          {FEATURES.map((f, i) => {
          const Icon = f.icon;
          return <motion.div key={f.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.1
          }} className="text-center" data-id="element-140" data-mp="2cxkx0n8cfaqh" data-mpi={i}>
                <span className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-deep-blue/5" data-id="element-141" data-mp="2hul6l84eivmc">
                  <Icon className="h-7 w-7 text-deep-blue" aria-hidden="true" data-id="element-142" data-mp="2vp5ccnjgtmly" />
                </span>
                <h3 className="font-display text-lg font-bold text-deep-blue" data-id="element-143" data-mp="35lgtbqu030mq">
                  {f.title}
                </h3>
                <p className="mt-1 text-[15px] text-ink/70" data-id="element-144" data-mp="30m481ais21m9">{f.text}</p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}